/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    table: {
        borderCollapse: 'collapse',
        width: {base: '100%', sm: '80%', md: '60%'},
        my: '6',
        borderRadius: 'lg'
    },
    th: {
        border: '1px solid #A0A0A0',
        padding: '4',
        textAlign: 'left',
        background: '#000',
        color: '#fff'
    },
    td: {
        border: '1px solid #A0A0A0',
        padding: '4',
        textAlign: 'left'
    },
    p: {
        padding: '8px 0'
    },
    ul: {
        ml: 6
    },
    li: {
        lineHeight: 8,
        fontWeight: 'medium'
    }
}
